import { Card } from "../ui/card";
import { Button } from "../ui/button";
import { RefreshCwIcon } from "lucide-react";
import { useTranslation } from "@/hooks/useTranslation";
import { useQueryClient } from "@tanstack/react-query";
import { reloadApp } from "@/lib/reloadApp";

export default function AppReloadCard() {
  const t = useTranslation();
  const queryClient = useQueryClient();

  return (
    <Card className="dark w-full max-w-lg p-4 items-center flex flex-row sm:flex-row gap-2">
      <Button variant="outline" onClick={() => reloadApp(queryClient)}>
        <RefreshCwIcon className="mr-4" />
        {t.APP_RELOAD_CARD.LABELS.TITLE}
      </Button>
      <div className="text-sm text-gray-400">
        {t.APP_RELOAD_CARD.LABELS.DESCRIPTION}
      </div>
    </Card>
  );
}
